<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回">
      </f7-nav-left>
      <f7-nav-title>智能报表</f7-nav-title>
    </f7-navbar>
    <div class="has-content" style="padding: 0rem 0rem;">
      <div>
        <img src="@/assets/img/report.png" width="100%" />
      </div>
    </div>
  </f7-page>
</template>
<script>

export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

</style>



// WEBPACK FOOTER //
// src/pages/report/index.vue